import KEY from "../clientVariables.json";

function url(api) {
  let API_SERVICE = KEY?.domain;
  let PARSER_SERVICE = KEY?.resume_parser_ai;
  let VMAIL_SERVICE = KEY?.domain_vmail;
  let JNP_API_SERVICE = KEY?.domain_jnp;

  switch (api) {
    case "login":
      return `${API_SERVICE}/user/login`;

    case "logout":
      return `${API_SERVICE}/user/logout`;

    case "resume_parser_ai":
      return `${PARSER_SERVICE}`;

    case "candidates":
      return (userid, page, limit) =>
        `${API_SERVICE}/user/${userid}/candidates/${page}/${limit}`;

    case "candidates_search":
      return (userid, page, limit, searchText) =>
        `${API_SERVICE}/user/${userid}/candidates/${page}/${limit}/${searchText}`;

    case "candidate":
      return (candidateID) => `${API_SERVICE}/candidate/${candidateID}`;

    case "user_submissions":
      return (userid, page, limit) =>
        `${API_SERVICE}/user/${userid}/submissions/${page}/${limit}`;

    case "candidate_submissions":
      return (userid, candidateID, page, limit) =>
        `${API_SERVICE}/candidate/${userid}/${candidateID}/submissions/${page}/${limit}`;

    case "solr_jobs":
      return `${API_SERVICE}/solr/jobs`;

    case "solr_jobs_with_submission":
      return `${API_SERVICE}/solr/jobs-with-submission-status`;

    case "submission_types":
      return () => `${API_SERVICE}/common/submission_types`;

    case "candidate_resume":
      return (userid, candidateID, filename) =>
        `${API_SERVICE}/candidate/${userid}/${candidateID}/${filename}`;

    case "candidate_documents":
      return (candidateID, userid) =>
        `${API_SERVICE}/candidate/${candidateID}/documents/${userid}`;

    case "job_details":
      return (jobId) => `${API_SERVICE}/job/${jobId}`;

    case "send_job_to_candidate":
      return `${API_SERVICE}/submission/send_job_to_candidate`;

    case "submissions_by_job":
      return (userid, candidateID, jobId) =>
        `${API_SERVICE}/submission/${userid}/${candidateID}/${jobId}`;

    case "update_submissions":
      return `${API_SERVICE}/submission/update_submission_status`;

    case "send_profile_to_vendor":
      return `${API_SERVICE}/submission/send_profile_to_vendor`;

    case "send_candidate_profile_to_vendors":
      return `${API_SERVICE}/submission/send-candidate-profile-to-vendors`;

    case "rate_confirmation":
      return `${API_SERVICE}/submission/update_candidate_rate`;

    case "interview_schedule":
      return `${API_SERVICE}/submission/schedule_interview`;

    case "update_interview":
      return `${API_SERVICE}/submission/update_schedule_interview`;

    case "add_candidate":
      return `${API_SERVICE}/candidate/add`;

    case "update_candidate":
      return (candidateID) => `${API_SERVICE}/candidate/update/${candidateID}`;

    case "get_states":
      return (countryid) => `${API_SERVICE}/common/${countryid}/states`;

    case "get_cities":
      return (stateID) => `${API_SERVICE}/common/${stateID}/cities`;

    case "get_jobtypes":
      return `${API_SERVICE}/common/jobtypes`;

    case "get_countries":
      return `${API_SERVICE}/common/countries`;

    case "candidate_attachment_file":
      return (userid, candidateID, filename) =>
        `${API_SERVICE}/candidate/${userid}/${candidateID}/${filename}`;

    case "upload_documents":
      return `${API_SERVICE}/candidate/upload_document`;

    case "share_profile":
      return `${API_SERVICE}/candidate/share_profile`;

    case "get_zipcodes":
      return (cityId) => `${API_SERVICE}/common/${cityId}/zipcodes`;

    case "Vmail_signin":
      return `${VMAIL_SERVICE}/api/v1/login`;

    case "Vmail_signup":
      return `${VMAIL_SERVICE}/api/v1/register`;

    case "active_candidates":
      return (userid, page, limit) =>
        `${API_SERVICE}/candidate/${userid}/active_candidates/${page}/${limit}`;

    case "Inactive_candidates":
      return (userid, page, limit) =>
        `${API_SERVICE}/candidate/${userid}/Inactive_candidates/${page}/${limit}`;

    case "update_candidate_status":
      return `${API_SERVICE}/candidate/update_candidates_status`;

    case "get_sources":
      return (page, limit) => `${API_SERVICE}/job/sourceNames/${page}/${limit}`;

    case "interestedJob":
      return `${API_SERVICE}/candidate/interestedJob`;

    case "check_interested_job":
      return `${API_SERVICE}/candidate/check_interested_job`;

    case "candidate_login":
      return `${API_SERVICE}/candidate/login`;

    case "update_primary_resume":
      return `${API_SERVICE}/candidate/set_primary_resume`;

    case "get_primary_resume":
      return `${API_SERVICE}/candidate/get_primary_resume_details`;

    case "get_recruiters_interested_job_candidates":
      return `${API_SERVICE}/candidate/get_interested_job_recuiters`;

    case "create_notification":
      return `${API_SERVICE}/common/create_notification`;

    case "get_my_recruiters":
      return `${API_SERVICE}/user/get_my_active_recruiters`;

    case "add_or_edit_recruiter":
      return `${API_SERVICE}/user/add_or_edit_rec_or_bs`;

    case "get_candidate_resume_list":
      return `${API_SERVICE}/common/get_candidate_resumes_list`;

    case "get_submission_status":
      return `${API_SERVICE}/submission/get-submission-status`

    case "get_candidate_resume_list_temp":
      return `${API_SERVICE}/common/get_candidate_resumes_list/temp`;

    case "assign_candidate_to_recruiter":
      return `${API_SERVICE}/candidate/assign_candidate_to_recruiter`;

    case "get_assigned_candidates":
      return `${API_SERVICE}/candidate/get-my-candidates`;

    case "admin_access":
      return `${API_SERVICE}/user/update_usertype`;

    case "remove_assigned_candidate":
      return `${API_SERVICE}/candidate/remove_assigned_candidate`;

    case "update_recruiter_status":
      return `${API_SERVICE}/user/update_recruiter_status`;

    case "get_my_Inactive_recruiters":
      return `${API_SERVICE}/user/get_my_Inactive_recruiters`;

    case "delete_resume":
      return `${API_SERVICE}/common/delete_resume`;

    case "get_role_Jobs_count_reports":
      return `${API_SERVICE}/common/get_role_Jobs_count_reports`;

    case "get_interested_joblist":
      return `${API_SERVICE}/candidate/get_interested_joblist`;

    case "get_jobs_count":
      return `${API_SERVICE}/candidate/jobs/count`;

    case "candidate_jobDetails":
      return (candidate_id) => `${API_SERVICE}/candidate/jobs/${candidate_id}`;

    case "jobtype_jobids":
      return `${API_SERVICE}/job/jobtype/ids`;

    case "getjobs_db":
      return `${API_SERVICE}/common/get_jobs`;

    case "get_interested_jobs_candidate":
      return (candidate_id) =>
        `${API_SERVICE}/candidate/${candidate_id}/interest_jobs`;

    case "get_search_suggestions":
      return `${API_SERVICE}/common/suggestions`;

    case "get_submission_resume_details":
      return `${API_SERVICE}/candidate/get_submission_resume_details`;

    case "get_user_last_seen":
      return `${API_SERVICE}/user/get_user_last_seen`;

    case "get_users_last_seen":
      return `${API_SERVICE}/user/get_users_last_seen`;

    case "get_js_full_resume_details":
      return `${API_SERVICE}/common/get_js_resume_details`;

    case "company":
      return `${API_SERVICE}/user/company`;

    case "update_viewed_status":
      return `${API_SERVICE}/submission/update-viewed-status`

    case "send_demo_request":
      return `${API_SERVICE}/common/send_demo_request`;

    case "get_company_package_data":
      return `${API_SERVICE}/user/get-company-package-data`;

    case "update_package_alert_log":
      return `${API_SERVICE}/user/update-package-alert-log`;

    default:
      return API_SERVICE;
  }
}

export default url;
